import { isPending } from "App/apiMiddleware";
import { USER_STATUS } from "Common/dictionaries/userStatus";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import reject from "lodash/reject";
import values from "lodash/values";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getSelf = (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].self`);
export const getUsersDataMap = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].list`), (data) => data);
export const getUsersData = createSelector((state) => getUsersDataMap(state), (data) => (data ? orderBy(values(data), ["Id"], ["desc"]) : undefined));
export const getUsersAllStatusDictionary = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].userStatusDictionary`), (data) => data);
export const getUserStatusDictionary = createSelector((state) => getUsersAllStatusDictionary(state), (userStatusDictionary) => userStatusDictionary
    ? reject(values(userStatusDictionary), ["Id", USER_STATUS.DELETED])
    : userStatusDictionary);
export const getInProgress = (state) => isPending(state, actionTypes.GET_USERS) ||
    isPending(state, actionTypes.BLOCK_USERS) ||
    isPending(state, actionTypes.UNBLOCK_USERS) ||
    isPending(state, actionTypes.REMOVE_USERS);
